import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import Immersive3dTourWithZipProcessRepository from "~/repository/Immersive3dTour/Immersive3dTourWithZipProcessRepository";

class Immersive3dTourWithZipProcessStore extends NestStore {
  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {Immersive3dTourWithZipProcessRepository|null}
   */
  immersive3dTourWithZipProcessRepository = null;

  constructor() {
    super();

    this.immersive3dTourWithZipProcessRepository = new Immersive3dTourWithZipProcessRepository();
  }

  @action
  update(data) {
    this.isLoading = true;

    return this.immersive3dTourWithZipProcessRepository
      .update(this.tourId, data)
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default Immersive3dTourWithZipProcessStore;
